import React from "react";
import "./AboutMe.css";
import { FaCheckCircle } from "react-icons/fa";

const AboutMe = () => {
  return (
    <section className="about-container">
       <div className="col-md-6 text-center">
          <img
            src="/portfolio pic 2.png"
            alt="Maryann Ichaura"
            className="img-fluid rounded-circle"
          />
        </div>
      <div className="about-text-container">
        <h2 className="about-heading">About Me</h2>
        <p className="about-description">
          Hi! I'm Maryann Ichaura, a Business Support Virtual Assistant dedicated to
          helping businesses stay organized and efficient. With expertise in executive
          support, data entry, CRM management, customer service, digital marketing, and
          social media management, I ensure seamless operations so you can focus on growth.
        </p>
        <h3 className="about-subheading">Why Work With Me?</h3>
        <ul className="about-list">
          <li><FaCheckCircle className="icon" /> Detail-oriented & highly organized</li>
          <li><FaCheckCircle className="icon" /> Strong communication skills</li>
          <li><FaCheckCircle className="icon" /> Proficient in CRM & admin tools</li>
          <li><FaCheckCircle className="icon" /> Reliable & deadline-driven</li>
          <li><FaCheckCircle className="icon" /> Experienced in customer service, digital marketing & social media management</li>
        </ul>
        <h3 className="about-subheading">Fun Facts About Me</h3>
        <ul className="about-list fun-facts">
          <li>📚 Passionate about learning & self-improvement</li>
          <li>🌍 Love exploring new cultures & experiences</li>
          <li>🎨 Enjoy creative projects & content design</li>
        </ul>
      </div>
    </section>
  );
};

export default AboutMe;
